import * as cookie from 'react-cookie';
import * as React from 'react';

type UserState = 'provisional' | 'full';
interface LoginLinkState {
  userState?: UserState;
}

const withUserStateCookie = Component => (redirects: Record<UserState, string>) => {
  return class extends React.Component<{}, LoginLinkState> {
    constructor(props) {
      super(props);
      this.state = {
        userState: cookie.load('userState'),
      };
    }

    render() {
      const { userState } = this.state;
      const userStateUrl = userState && redirects[userState];
      if (userState) {
        return <Component userStateUrl={userStateUrl} />;
      } else return null;
    }
  };
};

export default withUserStateCookie;
